<template>

  <img
      class="leaflink-logo"
      alt="LeafLink Logo"
      :width="width"
      :src="require('@/assets/img/provider/leaflink-logo-text-black.svg')"
      @click="handleClick" />

</template>

<script>
export default {
  name: 'LeafLinkLogo',

  props: {
    width: {
      type: String,
      default: '100px'
    },
    linkTo: {
      type: String,
      default: null
    }
  },

  methods: {
    handleClick () {
      if (this.linkTo) this.$root.goTo(this.linkTo)
    }
  }
}
</script>

<style>
  .leaflink-logo {
    cursor: pointer;
  }
</style>
